import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__SliderDefault } from './ScrollItem__SliderDefault';
import { Metrics } from '../_app/cuchillo/core/Metrics';

export class ScrollItem__BlockLanding extends ScrollItem__SliderDefault {
    figures = [];
    offset;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.figures = GetBy.class('__item', __link);
    }

    loop() {
        if (this.swiper) this.swiper.loop();

        const y = Maths.clamp(Maths.map(this.progress, this.offset, 1, 0, 40), 0, 100);
        gsap.set(this.figures, { y: `${y}%` });
    }

    resize(w, h) {
        super.resize(w, h);

        const rect = this.item.getBoundingClientRect();
        this.offset = 1 - (rect.height / Metrics.HEIGHT * .5);
    }
}

Scroll._registerClass('BlockLanding', ScrollItem__BlockLanding);
